import { SearchFormStore } from './search-form';
import { getSletatSearchUrl, addVersionId } from '../../utils/url';


export class MainStore {

    constructor(private searchForm: SearchFormStore) {}

    searchToursForAnotherHotel(): void {
        const params = this.searchForm.searchRequestParams;
        const url = addVersionId(getSletatSearchUrl({
            cityFromId: params.cityFromId,
            countryToId: params.countryToId,
            resortsIds: params.resortsIds,
            hotelsIds: [], // сбрасываем отель
            mealsIds: params.mealsIds,
            hotelsCategoriesIds: params.hotelsCategoriesIds,
            minHotelRating: params.minHotelRating,
            minNightsCount: params.minNightsCount,
            maxNightsCount: params.maxNightsCount,
            kidsCount: params.kidsCount,
            kidsAges: params.kidsAges,
            adultsCount: params.adultsCount,
            currency: params.currency,
            minPrice: params.minPrice,
            maxPrice: params.maxPrice,
            minDepartureDate: params.minDepartureDate,
            maxDepartureDate: params.maxDepartureDate,
            operatorsIds: params.operatorsIds,
            isTicketsIncluded: params.isTicketsIncluded,
            hasTickets: params.hasTickets,
            hotelIsNotInStop: params.hotelIsNotInStop,
            beachLines: params.beachLines,
            callback: 'search'
        }));

        window.open(url, '_self');
    }

}
